import rayid from "rayid";

const ray = new rayid();

export default ray;
